// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
interface EventProps {
  key: string
  count?: number
  sum?: number
  dur?: number
  segmentation?: Record<string, string>
}

interface UserDetailProps {
  name?: string
  username?: string
  email?: string
  organization?: string
  phone?: string
  //Web URL to picture
  picture?: string
  gender?: string
  byear?: number
  custom: Record<string, string>
}

const OrginCountly = {
  add_business_event: (props: EventProps) => {
    window.Countly.add_business_event(props)
  },
  add_technology_event: (props: EventProps) => {
    window.Countly.add_technology_event(props)
  },
  user_details: (props: UserDetailProps) => {
    window.Countly.user_details(props)
  },
}

export const appCountly = new Proxy(OrginCountly, {
  get(target, prop: string) {
    if (!window.Countly) {
      return () => {
        console.warn(`Countly: 未初始化`)
      }
    } else if (prop in target) {
      return target[prop]
    } else if (window.Countly[prop]) {
      return window.Countly[prop]
    } else {
      return () => {
        console.warn(`Countly: 方法 ${String(prop)} 暂不支持`)
      }
    }
  },
})
